module.exports = {"buildTime":"2026-03-12 14:52:58"}


//////////////////
// WEBPACK FOOTER
// P:/Work/htdocs/biatlon/online/src/components/utils/.env.json
// module id = 705
// module chunks = 0